// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import 'babel-polyfill'

Vue.config.productionTip = false
import '@/assets/css/base.css'
import '@/assets/css/public.css'
import 'element-ui/lib/theme-chalk/index.css'
// import 'animate.css'

//过滤字符串长度
Vue.filter('filterString',(value,lengths)=>{
  if(value.length < lengths){
    return value;
  }else{
    let interceptStr = value.substr(0,lengths);
    return interceptStr + '...';
  }
})

import vueTap from 'v-tap';
Vue.use(vueTap);

/*import {
  Button,
  Dialog
} from 'element-ui'
Vue.use(Button)
Vue.use(Dialog)*/
/* eslint-disable no-new */


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js